<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <v-card outlined elevation="19" class="transparent-card">
          <div class="header d-flex flex-column mb-2">
            <div class="text-h5 font-weight-light text-center mt-15 mb-10">
              Conclusão de Atendimento
            </div>
          </div>
          <div class="content">
            <v-form ref="form" class="mt-4">
              <v-row justify="center" class="text-center mb-4">
                <v-col cols="12">
                  <span class="text-body-1 font-weight-light">
                    A sua solicitação foi
                    <span class="font-weight-bold gray4--text">atendida</span>?
                  </span>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-radio-group v-model="form.answered" row>
                      <v-radio label="Sim" value="true" />
                      <v-radio label="Não" value="false" />
                    </v-radio-group>
                  </v-col>
                </v-col>
              </v-row>
              <div class="footer d-flex mt-6 justify-center mb-7">
                <v-btn
                  class="ml-3 font-weight-regular"
                  elevation="1"
                  color="success"
                  @click="submit()"
                >
                  <span> Prosseguir </span>
                </v-btn>
              </div>
            </v-form>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { updateAttendance } from "@/services/attendance";
import { getCounter } from "@/services/counters";
import { handleAlert } from "@/utils";

export default {
  name: "Rating",
  data() {
    return {
      form: {
        answered: "true",
      },
      counter: null,
    };
  },

  beforeMount() {
    this.getCounter();
  },

  methods: {
    async submit() {
      const id = this.$route.params.attendanceID;

      const values = {
        rating: {
          answered: this.form.answered,
        },
      };

      try {
        await updateAttendance(id, values);

        if (this.counter?.externalRating && this.counter?.externalRatingURL) {
          window.open(this.counter.externalRatingURL, "_blank");
        }

        this.$router.push(
          { path: "/home" },
          () => {},
          () => {}
        );
      } catch (error) {
        this.handleAlert(
          error.response?.data?.message || error.data.message,
          "error"
        );
      }
    },

    async getCounter() {
      try {
        const { data } = await getCounter(this.$route.params.deskID);

        this.counter = data;
      } catch (error) {
        console.log(error);
      }
    },

    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" />
